/**
 * <code>AnimationEvent</code> 类用于实现动画事件。
 */
export class AnimationEvent {
	/** 事件触发时间。*/
	time: number;
	/** 事件触发名称。*/
	eventName: string;
	/** 事件触发参数。*/
	params: any[];

	/**
	 * 创建一个 <code>AnimationEvent</code> 实例。
	 */
	constructor() {
	}

}


